<template>
    <b-modal
        v-if="group !== null"
        size="lg"
        v-model="modalShow"
        :title="`${groupTypeName}編集`"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <form @submit.stop.prevent="editGroup">
            <div>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="form-group m-form__group">
                            <label for="name" class="is-required-ja">{{ groupTypeName }}名</label>
                            <input
                                v-model="group.name"
                                id="name"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.name }"
                                type="text"
                                :placeholder="`${groupTypeName}名を入力`">
                            <div
                                v-if="errors.name"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.name[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="form-group m-form__group">
                            <label for="name_kana">{{ groupTypeName }}名（フリガナ）</label>
                            <input
                                v-model="group.name_kana"
                                id="name_kana"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.name_kana }"
                                type="text"
                                :placeholder="`${groupTypeName}名（フリガナ）を入力`">
                            <div
                                v-if="errors.name_kana"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.name_kana[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="form-group m-form__group">
                                <label for="address">住所</label>
                                <input
                                    v-model="group.address"
                                    id="address"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.address }"
                                    type="text"
                                    placeholder="住所を入力">
                                <div
                                    v-if="errors.address"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.address[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6">
                            <div class="form-group m-form__group">
                                <label for="tel">
                                    電話番号<span class="small">（滞在している国の国際番号）</span>
                                </label>
                                <vue-tel-input
                                    v-model="group.tel"
                                    id="tel"
                                    name="tel"
                                    :class="{ 'is-invalid' : errors.tel || telObj.valid === false }"
                                    placeholder="000-1111-2222"
                                    valid-characters-only
                                    default-country="JP"
                                    @validate="onValidateTel">
                                </vue-tel-input>
                                <div
                                    v-if="errors.tel"
                                    class="invalid-feedback d-block">
                                    {{ errors.tel[0] }}
                                </div>
                                <div
                                    v-if="telObj.valid === false"
                                    class="invalid-feedback d-block">
                                    電話番号を正しく入力してください
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="form-group m-form__group">
                            <label for="name">代表者名</label>
                            <input
                                v-model="group.representative"
                                id="representative"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.representative }"
                                type="text"
                                placeholder="代表者名を入力">
                            <div
                                v-if="errors.representative"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.representative[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="form-group m-form__group">
                            <label for="name_kana">代表者名（フリガナ）</label>
                            <input
                                v-model="group.representative_kana"
                                id="representative_kana"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.representative_kana }"
                                type="text"
                                placeholder="代表者名（フリガナ）を入力">
                            <div
                                v-if="errors.representative_kana"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.representative_kana[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="authorizer_memo">メモ</label>
                            <textarea
                                v-model="group.authorizer_memo"
                                id="memo"
                                rows="3"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.authorizer_memo }"
                                :placeholder="`メモを入力（所属${groupTypeName}および${$locale.patient}には表示されません）`"/>
                            <div
                                v-if="errors.authorizer_memo"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.authorizer_memo[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group m-form__group">
                            <label>管理用タグ</label>
                            <vue-tags-input
                                v-model="groupAuthorizerTag"
                                :tags="groupAuthorizerTags"
                                @tags-changed="tags => syncGroupAuthorizerTag(tags)"
                                placeholder="管理用タグを追加"
                            />
                            <div v-if="errors.group_authorizer_tags"
                                 class="invalid-feedback d-block">
                                {{ errors.group_authorizer_tags[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div
            slot="modal-footer"
            class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
            <button
                class="btn btn-yokumiru-orange float-right"
                :disabled="inProgress || telObj.valid === false"
                @click="handleOk">
                更新
            </button>
            <button
                class="btn btn-yokumiru-gray float-right mr-2"
                :disabled="inProgress"
                @click="close">
                キャンセル
            </button>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../../constants'
import YokumiruHelper from '../../../../YokumiruHelper'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    components: {
        VueTagsInput,
    },

    props: {
        parentGroup: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            group: null,
            groupAuthorizerTag: '',
            groupAuthorizerTags: [],
            telObj: {},
            errors: {},
        }
    },

    computed: {
        groupTypeName: function () {
            if (!this.group) return ''
            return this.helper.groupTypeName(this.group.group_type)
        },

        isOrganization: function () {
            if (!this.group) return false
            return this.group.group_type === constants.groupType.organization
        },

        isCompany: function () {
            if (!this.group) return false
            return this.group.group_type === constants.groupType.company
        },
    },

    created: function () {
        bus.$on('open-modal-authorizer-child-group-edit', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-authorizer-child-group-edit')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} group
         */
        open: function (group) {
            this.group = {...group}
            this.initGroupAuthorizerTag()
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.errors = {}
            this.modalShow = false
        },

        /**
         * 管理用タグ（担当者用）の初期化
         */
        initGroupAuthorizerTag: function () {
            if (!this.group || this.group.group_authorizer_tags.length < 1) {
                this.groupAuthorizerTags = []
                return
            }

            this.groupAuthorizerTags = this.group.group_authorizer_tags
                .filter((tag) => tag.authorizer_id === this.parentGroup.authorizer_id)
                .map((tag) => {
                return {
                    id: tag.id,
                    text: tag.name,
                    style: 'color: #5834b4; background-color: #f4f2f8; border: 1px solid #e2dced;',
                }
            })
        },

        /**
         * グループ管理用タグ（担当者用）追加時の同期処理
         * @param {array} tags
         */
        syncGroupAuthorizerTag: function (tags) {
            this.groupAuthorizerTags = tags.map((lbl) => {
                return {
                    text: lbl.text,
                    style: 'color: #5834b4; background-color: #f4f2f8; border: 1px solid #e2dced;',
                    tiClasses: ['ti-valid'], // VueTagsInputが自動生成している
                }
            })
        },

        /**
         * 更新ボタン押下時
         *
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.editGroup()
        },

        /**
         * グループ更新
         */
        editGroup: async function () {
            if (this.inProgress) return
            this.inProgress = true

            this.group.tel = this.telObj.number.e164 || ''
            this.group.tel_national = this.telObj.number.national
            this.group.tel_region = this.telObj.regionCode

            this.group.group_authorizer_tags = []
            this.groupAuthorizerTags.forEach((tag) => {
                if (tag.text) this.group.group_authorizer_tags.push(tag.text)
            })

            const endpoint = constants.user.groups.endpoint.base

            await axios.put(`${endpoint}/${this.parentGroup.id}/groups/${this.group.id}`, this.group)
                .then(() => {
                    bus.$emit('alert-success', `${this.groupTypeName}を更新しました。`)
                    bus.$emit('fetch-child-group')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger')
                        this.errors = response.data.errors
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },

        onValidateTel: function (object) {
            if (object.number.input) {
                this.telObj = object
            }
            else {
                this.telObj = {
                    number: { e164: null, national: null },
                    valid: true,
                    regionCode: null,
                }
            }
        },
    },
}
</script>
